import { Box, Button, Card, CircularProgress, Container, Typography } from "@mui/material";
import { useState } from "react";
import { enqueueSnackbar } from "notistack";
import axios, { endpoints, formatEndpoint } from 'src/utils/axios';
import { useSettingsContext } from "src/components/settings";
import Iconify from "src/components/iconify/iconify";
import { addDaysToDate, formatDateForPreview, today } from "src/utils/date-utils";
import TruxSimpleDateField from "src/components/inputs/trux-simple-date-field";
import { ColoredIcon } from "src/components/colored-icon";


export default function Page() {
  const settings = useSettingsContext();

  const [fromDate, setFromDate] = useState(today());
  const [toDate, setToDate] = useState(addDaysToDate(today(), -30));

  const [loading, setLoading] = useState(false);
  const [csvUrl, setCsvUrl] = useState(null as string | null);
  return (
    <Container maxWidth={settings.themeStretch ? false : 'lg'}>
      <Card sx={{p: 4, display: "flex", flexDirection:"column", alignItems: "center", gap: 4}}>
        {!csvUrl && <Typography variant="h4">
          IFTA Report
        </Typography>}

        <Box maxWidth="300px" width="100%" display="flex" flexDirection="column" alignItems="center" gap={2}>
          {csvUrl ? <>
              <Box textAlign="center">
                <ColoredIcon color="success">
                  <Iconify icon="solar:check-circle-bold" width={44} />
                </ColoredIcon>
              </Box>
              <Box textAlign="center">
                IFTA File successfully generated <br /> {formatDateForPreview(fromDate)} to {formatDateForPreview(toDate)}
              </Box>

              <Box display="flex" flexDirection="row" gap={2}>
                <Button
                  variant="outlined"
                  color="inherit"
                  sx={{mt:2}} onClick={() => {
                    setLoading(false);
                    setCsvUrl(null);
                  }}>
                  Back
                </Button>
                <Button
                  variant="outlined"
                  color="success"
                  sx={{mt:2}}
                  startIcon={<Iconify icon="basil:file-download-outline" />}
                  href={csvUrl}
                  download={`IFTA Report ${fromDate} ${toDate}.csv`}
                  target="_blank"
                  rel="noopener noreferrer">
                  Download
                </Button>
              </Box>
            </> : <>
            {loading && <Box display="flex" flexDirection="column" alignItems="center" gap={4} pt={6} pb={6}>
            <CircularProgress size={50} sx={{mt: 5}} />
            <Box><i>Downloading...</i></Box>
          </Box>}

          {!loading && <>
            <Box width="100%">
              <Typography component="div" fontWeight={700}>From Date</Typography>
              <TruxSimpleDateField value={fromDate} onChange={d => setFromDate(d!)} limitWidth={false} />
            </Box>

            <Box width="100%">
              <Typography component="div" fontWeight={700}>To Date</Typography>
              <TruxSimpleDateField value={toDate} onChange={d => setToDate(d!)} limitWidth={false} />
            </Box>

            <Button variant="contained" color="success" sx={{mt:2}} startIcon={<Iconify icon="basil:file-download-outline" />} onClick={() => {
              setLoading(true);

              axios({url: formatEndpoint(endpoints.eldIftaReport, {fromDate, toDate}), method: 'GET',
              responseType: 'blob',}).then((response) => {
                setLoading(false);
                const blob = new Blob([response.data], { type: 'text/csv' });
                const url = window.URL.createObjectURL(blob);

                setCsvUrl(url)
              }).catch(() => {
                setLoading(false);
                enqueueSnackbar("Unexpected exception has occured. Please contact customer support.", {variant: "error"})
              })
            }}>
              Generate
            </Button>
          </>}
          </>}
        </Box>
      </Card>
    </Container >
  );
}
